const SectionContact = () => (
  <section id="contact" className="py-16 md:py-20 bg-background-50">
    <div className="max-w-[1280px] mx-auto px-4 md:px-6">
      <div className="max-w-[700px] mx-auto text-center p-8 md:p-12 rounded-2xl bg-gradient-to-br from-primary-500 to-primary-600">
        <span className="w-14 h-14 flex items-center justify-center rounded-full bg-background-50/20 mx-auto">
          <i className="ri-mail-send-line text-2xl text-background-50"></i>
        </span>
        <h2 className="mt-5 text-2xl md:text-3xl font-heading font-bold text-background-50">爆料投稿</h2>
        <p className="mt-3 text-sm md:text-base text-background-50/80 leading-relaxed">
          你有独家爆料？知道不为人知的内幕？吃瓜网每日大赛欢迎各路知情人士投稿。您的每一条线索，都可能成为明天的头条大瓜。我们承诺对爆料人信息严格保密。
        </p>
        <div className="mt-6 flex flex-col sm:flex-row items-center justify-center gap-3">
          <span className="inline-flex items-center gap-2 px-5 py-2.5 rounded-lg bg-background-50 text-primary-600 font-semibold text-sm whitespace-nowrap cursor-pointer hover:bg-background-100 transition-colors">
            <i className="ri-wechat-line"></i>
            微信投稿通道
          </span>
          <span className="inline-flex items-center gap-2 px-5 py-2.5 rounded-lg bg-background-50/15 text-background-50 font-semibold text-sm border border-background-50/30 whitespace-nowrap cursor-pointer hover:bg-background-50/25 transition-colors">
            <i className="ri-mail-line"></i>
            邮箱：tips@chiguawang.com
          </span>
        </div>
      </div>
    </div>
  </section>
);

export default SectionContact;